import * as React from 'react';

import { Box } from '../box/Box';
import { Text } from '../text';
import { CheckboxGroup } from '../../atoms/form';

export function CheckboxTitle(props) {
  return (
    <Box
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      style={{ marginBottom: 5 }}
      id={props.id}
    >
      <Text weight="600" size={14} color="#90A4AE">
        {props.title}
      </Text>
      <CheckboxGroup name={props.name} values={[props.value]} />
    </Box>
  );
}
